import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export const useLog = defineStore('log', {
  state: () => ({}),
  actions: {
    // 日志分页列表
    async getLogPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/sysOpRecord/getPage',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除日志
    async deleteLogInfo(id: string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/sysOpRecord/del?id=${id}`,
          method: 'post'
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 日志详情
    async getLogInfo(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/sysOpRecord/info',
          method: 'get',
          params
        })
          .then((res) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
